import { IFileSelected } from 'components/FileUploader/interface'

export const FILE_SELECTED_INITIAL_STATE: IFileSelected = { rejected: false }
